import { getSPDataWithParams, postSPDataWithoutParams } from './services'
import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'

function getResponseMessage(response, fallbackMessage) {
  return (
    response?.data?.message ||
    response?.response?.data?.message ||
    response?.message ||
    fallbackMessage
  )
}

export async function getSupportPaymentLinks(params = {}) {
  const response = await getSPDataWithParams('/api/secure/cc/support/payment-links/list', params)

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    const data = getDataMapFromCommonResponse(response)
    return {
      ok: true,
      items: data?.items || [],
      countsByCategory: data?.countsByCategory || {},
      availableEventTypeGroups: data?.availableEventTypeGroups || [],
      page: Number(data?.page || 1),
      pageSize: Number(data?.pageSize || params?.limit || 20),
      totalItems: Number(data?.totalItems || 0),
      totalPages: Number(data?.totalPages || 0),
      hasNext: Boolean(data?.hasNext),
      rawResponse: response,
    }
  }

  return {
    ok: false,
    items: [],
    countsByCategory: {},
    availableEventTypeGroups: [],
    page: 1,
    pageSize: Number(params?.limit || 20),
    totalItems: 0,
    totalPages: 0,
    hasNext: false,
    message: getResponseMessage(response, 'Unable to load payment links.'),
    rawResponse: response,
  }
}

export async function sendSupportPaymentLink(payload = {}) {
  const response = await postSPDataWithoutParams('/api/secure/cc/support/payment-links/send', payload)

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response),
      rawResponse: response,
    }
  }

  return {
    ok: false,
    message: getResponseMessage(response, 'Unable to send payment link.'),
    rawResponse: response,
  }
}

export async function createSupportPackPaymentLinkRequest(payload = {}) {
  const response = await postSPDataWithoutParams(
    '/api/secure/cc/support/payment-links/packs/create-request',
    payload,
  )

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    const data = getDataMapFromCommonResponse(response)
    return {
      ok: true,
      item: data?.item || null,
      data,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    item: null,
    message: getResponseMessage(response, 'Unable to create pack purchase request.'),
    rawResponse: response,
  }
}

export async function getSupportPatientPackHistory(patientId) {
  const response = await getSPDataWithParams('/api/secure/cc/support/patient/pack-history', {
    'patient-id': patientId,
  })

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    const data = getDataMapFromCommonResponse(response)
    return {
      ok: true,
      items: data?.items || [],
      rawResponse: response,
    }
  }

  return {
    ok: false,
    items: [],
    message: getResponseMessage(response, 'Unable to load pack history.'),
    rawResponse: response,
  }
}
